import { IFormViewForm } from 'components/FormView';

export const CalculatorDialogForm: IFormViewForm = {
  id: 'CalculatorDialogForm',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 1,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Credit amount',
            name: 'CreditAmount',
            placeholder: '',
            size: 'medium',
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 2
          }
        },
        {
          id: 2,
          type: 'EXTENDED_DISPLAY_FIELD',
          visible: true,
          props: {
            label: 'Restocking percentage',
            name: 'RestockingPercentage',
            size: 'small',
            type: 'number',
            decimalSeparator: true,
            adornment: '%',
          }
        },
      ]
    },
  ]
};
